import { render } from "./investigator-dashboard.html?vue&type=template&id=242cd20a&scoped=true&ts=true&external"
import script from "./investigator-dashboard.ts?vue&type=script&lang=ts&external"
export * from "./investigator-dashboard.ts?vue&type=script&lang=ts&external"

import "./investigator-dashboard.scss?vue&type=style&index=0&id=242cd20a&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242cd20a"]])

export default __exports__